/**
 * ErrorWatchStartIcon/index.tsx
 * desc: start error watch step icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
import IconButton, { type IconProps } from '../IconButton/typed';
import { translate } from '../../../utilities/localization';


const ErrorWatchStartIcon = ({ tooltip, ...props }: IconProps) => (
    <IconButton
        baseClassName="error-watch-start icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.errorWatchStart.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1 2 4.5v6.1c0 5 3.8 9.6 9 10.9 5.2-1.3 9-5.9 9-10.9V4.5L11 1Zm0 2.2 7 2.7v4.7c0 4-3 7.7-7 8.9-4-1.2-7-4.9-7-8.9V5.9l7-2.7Z"/>
            <path d="M9.2 8.1v6.8l5.4-3.4-5.4-3.4Z"/>
        </svg>
    </IconButton>
);


export default ErrorWatchStartIcon;
